<template>
  <div v-if="activityInfo" :class="['pullNewPrize', { inApp: $root.$data.isApp || this.$root.miniprogram }]"
    :style="{ background: 'url(' + activityInfo.activityBackgroundPicture + ') repeat' }">
    <CommonTitle :titleName="activityInfo.activityName" />
    <Banner :activityInfo="activityInfo" />
    <Rule :activityRule="activityInfo.activityRule" />
    <div class="prizeList">
      <img class="prizeListTitle" src="../../../assets/img/pullNew/prizeListTitle.png" alt />
      <div class="prizeItem" v-for="(item, index) in activityInfo.pullNewActivityPrizeDataList" :key="index">
        <div class="prizeImg">
          <img :src="item.prizePicture" alt />
        </div>
        <div class="prizeInfo">
          <h5>{{ item.prizeName }}</h5>
          <div class="surplus">
            <p class="surplusNum">
              剩余
              <span>{{ item.prizeStock }}</span> 份
            </p>
            <p class="surplusStep" v-if="item.exchangeType === 1">
              <span :style="{ 'width': (100 - (item.prizeStock / item.prizeNum * 100)) + '%' }"></span>
            </p>
          </div>
          <div class="receivePeople">
            <p>
              满
              <span>{{ item.number }}</span> 人可领
            </p>
            <div class="receiveBtn">
              <template>
                <div v-if="item.isReceive" class="receiveDone">
                  <p :class="['seePrize', { opacityPrize: item.prizeType === 2 }, { opacityPrizeHide: item.prizeType !== 2 }]"
                    @click="goToCourse(item)">去学习</p>
                  <p class="seePrize" @click="getMyPrizeInfo(item.activityPrizeId)">查看奖品</p>
                </div>

                <p v-else-if="!item.isGetReceive">已拥有</p>
                <p v-else-if="item.prizeStock === 0">已领完</p>
                <p class="gotoReceive"
                  v-else-if="activityInfo.pullNewActivityShareData.shareAssistanceNum >= item.number"
                  @click="receivePrizeBtn(item)">去领奖</p>

                <!-- 测试用 -->
                <!-- <p class="gotoReceive" @click="receivePrizeBtn(item)">
                  去领奖
                </p>-->

                <p v-else>
                  差
                  <span style="color: #FF1A3F">
                    {{ item.number -
                      activityInfo.pullNewActivityShareData.shareAssistanceNum }}
                  </span> 人
                </p>
              </template>
            </div>
          </div>
        </div>
      </div>
    </div>
    <Recommend :activityId="activityId" />
    <AppDown v-if="!(this.$root.ytMini || this.$root.pullNewType === 2)" />
    <van-popup v-model="prizeShow" class="prizePopup" :duration="0" :close-on-click-overlay="false" :closeable="true">
      <h5>温馨提示</h5>
      <div class="receiveTips">
        <div class="addressTips" v-if="needAddress">
          <div v-if="specJson.length === 0">
            <p>
              您领取的奖品需要寄送哦
              <br />请填写地址方便寄送~
            </p>
            <p>*未填写地址视为放弃奖品</p>
          </div>
          <div v-else>
            <p class="specTips">
              该奖品需要选择规格，请选择规格后
              <br />再进行地址填写~
            </p>
            <div class="specBox">
              <div v-for="(item, index) in specJson" :key="index">
                <!-- :class="checkSpec.find(item => item.check === v) ? 'active' : ''" -->
                <span class="spectitle">{{ item.name }}</span>
                <ul class="specList">
                  <li v-for="(v, key) in item.checkValues" :key="key"
                    :style="specStyle(v, index) ? specStyle(v, index) : (checkSpec.find(item => item.check === v) ? { color: '#FFF', background: '#ff1a3f' } : {})"
                    @click="changeSpec(v, index)">{{ v }}</li>
                </ul>
              </div>
            </div>
          </div>
        </div>
        <div class="courseCoupon" v-else>
          <p v-if="prizeType === 4">
            您领取的奖品为现金
            <br />活动结束后工作人员会联系你哦~
          </p>
          <p v-else>
            您领取的奖品为{{ productType == 2 ? '电子书' : '课程/优惠券' }}
            <br />请关注个人账户哦~
          </p>
        </div>
      </div>
      <div v-if="needAddress" @click="goToAddress" class="prizePopupBtn">去填写</div>
      <div v-else class="prizePopupBtn" @click="prizeShow = false">知道了</div>
    </van-popup>

    <PopupShow popupType="prize" :prizeInfo="myPrizeInfo" ref="popup" />
    <!-- 加群-->
    <van-popup v-model="showPop" position="bottom" class="showPopUp" :get-container="getContainer">
      <div class="close-btn" @click="showPop = false">
        <van-icon name="cross" />
      </div>
      <component v-if="showPop" :is="communityType | typeToComponentName" :communityInfo="communityInfo" />
    </van-popup>
  </div>
</template>
<script>
import { mapState } from 'vuex';
// eslint-disable-next-line import/no-cycle
import {
  getPullNewInfoApi,
  receivePrizeApi,
  myPrizeInfoApi,
  getCommunityDetails,
} from '@/api/pullNew';
// eslint-disable-next-line import/no-cycle
import { reqCheckProduct } from '@/api/pay';

import CommonTitle from '@/components/header/CommonTitle.vue';
import Banner from '../components/banner.vue';
import Rule from '../components/rule.vue';
import PopupShow from '../components/popupShow.vue';
import AppDown from '../components/appDown.vue';
import Recommend from '../components/recommends.vue';
import qqPopupComponent from '@/components/courseDetail/footCommuntiy/qqPopupComponent.vue';
import wxPopupComponent from '@/components/courseDetail/footCommuntiy/wxPopupComponent.vue';

export default {
  components: {
    CommonTitle,
    Banner,
    Rule,
    PopupShow,
    AppDown,
    Recommend,
    qqPopupComponent,
    wxPopupComponent,
  },
  data() {
    return {
      activityId: null,
      activityInfo: null,
      activityPrizeId: null, // 奖品ID
      prizeShow: false, // 未领取奖品时的弹窗
      specJson: [], // 实物规格
      checkSpec: [], // 选择的实物规格
      needAddress: false, // 是否需要添加地址
      prizeType: null, // 1 实物 2课程 3优惠券 4现金
      productType: null,  // 1 启航  2 电子书
      lock: true, // 领取奖品放连点
      myPrizeInfo: {}, // 已领取奖品的详情
      showPop: false, // 加群弹框
      communityInfo: {}, // 社群信息
      communityType: '', //社群按钮
    };
  },
  filters: {
    /** 根据type找到组件 */
    typeToComponentName(val) {
      let componentName;
      if (val === '1-1' || val === '1-2') {
        componentName = 'qqPopupComponent';
      } else if (val === '2-1' || val === '2-2' || val === 'wxAccount') {
        componentName = 'wxPopupComponent';
      }
      return componentName || '';
    },
  },
  computed: {
    ...mapState(['userInfo']),
    specStyle() {
      return function (v, index) {
        const aaa = this.specHas(v, index);
        return aaa
          ? { background: 'rgb(245, 245, 245)', border: '1px solid rgb(240, 240, 240)' }
          : false;
      };
    },
  },
  watch: {
    prizeShow(newVal) {
      if (!newVal) {
        const specLs = JSON.parse(JSON.stringify(this.checkSpec));
        this.checkSpec = specLs.map(item => ({ type: item.type }));
      }
    },
  },
  methods: {
    // 奖品规格判断函数
    specHas(currSpec, index) {
      // console.log('currSpec', this.specDanMap[currSpec])

      if (!this.specDanMap[currSpec]) {
        return true;
      }

      // console.log('kjinbuqbfor???', this.specMap)

      const specMapList = Object.keys(this.specMap);

      let seach = false;

      for (let i = 0; i < specMapList.length; i++) {
        const spec = specMapList[i];

        let is = false;

        // console.log('for - i', i, spec)

        for (let j = 0; j < this.checkSpec.length; j++) {
          const { check } = this.checkSpec[j];
          if (check && index !== j) {
            if (spec.indexOf(check) === -1) {
              break;
            }
            // console.log('tiapshi:', `i:${i}, j:${j}, spec:${spec}, check:${check}, currSpec:${currSpec}`)
          }
          // console.log('tiaoshi ', currSpec, i, j, spec, check, spec.indexOf(check))
          if (j === this.checkSpec.length - 1 && spec.indexOf(currSpec) !== -1) {
            is = true;
            seach = true;
          }
        }
        // console.log(is, i, this.specMap[specMapList[i]], 'is')
        if (is && this.specMap[specMapList[i]] > 0) {
          return false;
        }
      }
      if (seach) {
        return true;
      }
      return false;
    },

    async getActivityInfo() {
      this.$toast.loading({
        message: '加载中...',
        forbidClick: true,
        duration: 0,
      });
      const info = await getPullNewInfoApi(this.activityId, this.$route.query.preview || 0);
      this.$toast.clear();
      const { code, data, msg } = info;
      if (code === 0) {
        this.activityInfo = data;
        if (this.$root.$data.isApp) document.title = data.activityName;
        this.getSessionStorageData(); // 获取缓存中的信息
      } else {
        this.$toast.fail(msg);
      }
    },
    getContainer() {
      return document.querySelector('.entranceTask');
    },
    createImg() {
      // 判断登录状态
      this.$refs.canvasImg.createImg();
    },
    // 去领取
    receivePrizeBtn(data, isClear) {
      // console.log(data, isClear)
      // prizeType 1 实物 2课程 3优惠券 4现金
      // eslint-disable-next-line prefer-const
      let {
        activityPrizeId,
        prizeType,
        specJson,
        prizeSkuVOList,
        exchangeType,
        communityId,
      } = data;
      if (exchangeType === 1) {
        // if (specJson == null) specJson = '[]';
        this.activityPrizeId = activityPrizeId;
        if (prizeType === 1) {
          // const specJson = "[{\"id\":38,\"name\":\"颜色\",\"checkValues\":[\"红\",\"紫\"],\"addValues\":[]},{\"id\":28,\"name\":\"地域\",\"checkValues\":[\"北京\",\"上海\"],\"addValues\":[]}]"
          // const prizeSkuVOList = [
          //   { skuName: "红,北京", skuSales: 1, skuStock: 1 },
          //   { skuName: "红,上海", skuSales: 0, skuStock: 1 },
          //   { skuName: "紫,北京", skuSales: 0, skuStock: 1 },
          //   { skuName: "紫,上海", skuSales: 0, skuStock: 1 },
          // ]

          // 处理规格sku信息 规格：余量（限量 - 销量）
          let specMap = {};
          let specDanMap = {};

          prizeSkuVOList?.forEach(vo => {
            const { skuName, canExchange } = vo;
            specMap[skuName] = Number(canExchange);

            const danSpecList = skuName?.split(',') || [];
            if (canExchange) {
              danSpecList.forEach(d => {
                specDanMap[d] = true;
              });
            }
          });
          console.log('guige init', specMap, specDanMap);
          this.specMap = specMap;
          this.specDanMap = specDanMap;
          this.specJson = JSON.parse(specJson);

          if (!isClear) {
            // isClear 为true时 是去地址页回来的
            // this.checkSpec = this.specJson.map((item) => ({
            //   type: item.name,
            //   // check: item.checkValues[0],
            // }));
            this.checkSpec = this.specJson.map(item => {
              // const result = {
              //   type: item.name
              // }
              // if (item.checkValues.find((itm) => specDanMap[itm])) {
              //   result.check = item.checkValues.find((itm) => !!specDanMap[itm])
              // }
              return {
                type: item.name,
              };
            });
          }
          this.needAddress = true;
          this.prizeShow = true;
        } else {
          this.specJson = [];
          this.checkSpec = [];
          if (prizeType === 2) {
            // 查看课程是否需要添加地址
            this.courseDetail(data);
          } else {
            this.receivePrize(activityPrizeId);
          }
        }
      } else {
        this.getCommunityDetailsData(communityId);
      }
    },
    async getCommunityDetailsData(communityId) {
      const request = await getCommunityDetails(communityId);
      this.communityInfo = request.data;
      if (request.code === 0 && request.data) {
        const { data } = request;
        this.communityType = `${data.platform}-${data.accountType}`;
      } else {
        this.communityType = 'wxAccount';
      }
      this.showPop = true;
    },

    async courseDetail(info) {
      // 查看课程详情
      const { productId, productSkuId, activityPrizeId } = info;
      // 校验是否需要添加地址
      const subData = {
        products: [
          {
            productId,
            productSkuId,
            quantity: 1,
            type: 1,
          },
        ],
        userId: this.userInfo.id,
      };
      const { code, data } = await reqCheckProduct(subData);
      if (code === 0 && data.needAddress) {
        // 需要地址
        this.needAddress = true;
        this.prizeShow = true;
      } else {
        // 不需要地址
        this.receivePrize(activityPrizeId);
      }
    },
    // 奖品领取
    async receivePrize(activityPrizeId, addressId) {
      if (!this.lock) return;
      this.lock = false;
      const info = {
        activityId: this.activityId,
        activityPrizeId,
        ip: '',
        terminalMark: 1,
        userAddressId: addressId || '',
        specJson: JSON.stringify(this.checkSpec),
      };
      const { code, data, msg } = await receivePrizeApi(info);
      if (code === 0) {
        if (addressId) {
          this.$toast.success('领取成功');
        } else {
          this.needAddress = false;
          this.prizeShow = true;
          this.prizeType = data.prizeType;
          this.productType = data.productType
        }
        this.getActivityInfo();
      } else {
        this.$toast.fail(msg);
      }
      const specLs = JSON.parse(JSON.stringify(this.checkSpec));
      this.checkSpec = specLs.map(item => ({ type: item.type }));
      this.lock = true;
    },
    changeSpec(value, index) {
      // this.checkSpec[index].check = value;

      const aaa = this.specHas(value, index);
      console.log('aaabian', aaa);
      if (aaa) {
        this.$toast({
          message: '奖品送光啦，请选择其他奖品吧',
          className: 'toastIndex',
        });
        return;
      }
      const ls = this.checkSpec;
      ls[index].check = value;
      console.log('ls', ls);
      this.checkSpec = ls;
      setTimeout(() => {
        this.specJson = [...this.specJson];
        console.log(this.checkSpec);
      }, 0);
    },
    goToAddress() {
      if (this.specJson && this.specJson.length > 0) {
        const isLq = this.checkSpec.every(spec => !!spec.check);
        if (!isLq) {
          this.$toast({
            message: '请选择要领取的奖品规格',
            className: 'toastIndex',
          });
          return;
        }
      }
      sessionStorage.setItem('activityPrizeId', this.activityPrizeId);
      if (this.checkSpec.length)
        sessionStorage.setItem('checkSpec', JSON.stringify(this.checkSpec));
      this.$router.push({
        path: '/personalCenter/address',
        query: {
          needBack: true,
          pullNewType: this.$root.pullNewType === 2 ? 'yt' : ''
        },
      });
    },
    async getMyPrizeInfo(activityPrizeId) {
      const info = {
        activityPrizeId,
        activityId: this.activityId,
      };
      const { code, data, msg } = await myPrizeInfoApi(info);
      if (code === 0) {
        this.myPrizeInfo = data;
        this.$refs.popup.show = true;
      } else {
        this.$toast.fail(msg);
      }
    },
    // 获取缓存在本地的数据 用于添加完地址处理后续逻辑
    getSessionStorageData() {
      const activityPrizeId = JSON.parse(sessionStorage.getItem('activityPrizeId'));
      const addressId = JSON.parse(sessionStorage.getItem('addressId'));
      let checkSpec = sessionStorage.getItem('checkSpec');

      checkSpec = checkSpec ? JSON.parse(checkSpec) : [];
      if (activityPrizeId && addressId && checkSpec.length) {
        // 实物有规格 填完地址回来的
        this.checkSpec = checkSpec;
        this.receivePrize(activityPrizeId, addressId);
      } else if (activityPrizeId && checkSpec.length) {
        // 实物有规格 未添地址 需回显操作
        this.checkSpec = checkSpec;
        const data = this.activityInfo.pullNewActivityPrizeDataList.find(
          item => item.activityPrizeId === activityPrizeId,
        );
        this.receivePrizeBtn(data, true);
      } else if (activityPrizeId && addressId) {
        // 非有规格 填完地址
        this.receivePrize(activityPrizeId, addressId);
      }
      sessionStorage.removeItem('activityPrizeId');
      sessionStorage.removeItem('addressId');
      sessionStorage.removeItem('checkSpec');
    },

    async goToCourse(data) {
      const { productId, productSkuId, activityPrizeId } = data;
      if (this.$root.$data.isApp) {
        this.$sendToApp('goCourseDetail', Number(productId), false);
        return;
      }
      sessionStorage.setItem('back', 'back');
      this.$router.push({
        path: '/courseDetail',
        query: {
          courseId: productId,
        },
      });
    },
  },
  mounted() {
    this.getActivityInfo();
    if (this.$root.ytMini || this.$root.pullNewType === 2) {
      document.title = '云图书吧';
    }
  },
  created() {
    const { activityId } = this.$route.query;
    this.activityId = activityId;
  },
};
</script>
<style lang="scss">
.toastIndex {
  z-index: 10000001 !important;
}
</style>
<style scoped lang="scss">
.pullNewPrize {
  min-height: 100vh;
  padding: 100px 0 200px;
  background: #fff;

  &.inApp {
    padding-top: 0;
  }

  .prizeList {
    box-sizing: border-box;
    width: 686px;
    min-height: 300px;
    margin: 49px auto 0;
    padding: 0 32px 32px;
    background: #fff;
    border-radius: 40px;

    .prizeListTitle {
      display: block;
      width: 474px;
      height: 102px;
      margin: 0 auto 40px;
    }

    .prizeItem {
      display: flex;
      align-items: center;
      justify-content: space-between;
      box-sizing: border-box;
      width: 100%;
      min-height: 202px;
      margin-top: 24px;
      padding: 24px 32px;
      background: #fff7f9;
      border-radius: 40px;

      .prizeImg {
        width: 136px;
        height: 136px;
        background: url('../../../assets/img/pullNew/prizeItemBg.png') no-repeat;
        background-size: 100% auto;

        img {
          box-sizing: border-box;
          width: 100%;
          height: 100%;
          padding: 3px;
          border-radius: 24px;
        }
      }

      .prizeInfo {
        width: 400px;

        h5 {
          width: 100%;
          overflow: hidden;
          font-size: 32px;
          white-space: nowrap;
          text-overflow: ellipsis;
        }

        .surplus {
          display: flex;
          align-items: center;
          width: 100%;
          height: 50px;

          .surplusStep {
            position: relative;
            width: 100px;
            height: 8px;
            background: #fff;
            border-radius: 8px;

            span {
              position: absolute;
              width: 20%;
              height: 100%;
              background: #ff1a3f;
              border-radius: 8px;
            }
          }

          .surplusNum {
            margin-right: 8px;
          }
        }

        p {
          color: #999;
          font-size: 24px;

          span {
            color: #333;
            font-size: 24px;
          }
        }

        .receivePeople {
          display: flex;
          align-items: center;
          justify-content: space-between;
          height: 52px;

          .receiveBtn {
            >p {
              display: flex;
              align-items: center;
              justify-content: center;
              // width: 100%;
              // height: 100%;
              width: 130px;
              height: 52px;
              background: #f2f2f2;
              border-radius: 36px;
            }

            .gotoReceive {
              color: #fff;
              background: linear-gradient(180deg, #ff5a38 0%, #ff1a3f 100%);
            }

            .receiveDone {
              display: flex;
              align-items: center;
              justify-content: space-between;
              width: 252px;

              .seePrize {
                height: 52px;
                padding: 0 16px;
                color: #ff1a3f;
                font-weight: 500;
                font-size: 24px;
                line-height: 52px;
                background: #ffe6ea;
                border-radius: 36px;
              }

              .opacityPrize {
                opacity: 1;
              }

              .opacityPrizeHide {
                opacity: 0;
              }
            }
          }
        }
      }
    }
  }

  .prizePopup {
    box-sizing: border-box;
    width: 622px;
    padding: 48px;
    // min-height: 470px;
    background: #fff;
    border-radius: 32px;

    h5 {
      width: 100%;
      color: #333;
      font-weight: 500;
      font-size: 36px;
      text-align: center;
    }

    .receiveTips {
      padding: 48px 0;

      p {
        width: 100%;
        color: #333;
        font-weight: 400;
        font-size: 28px;
        line-height: 40px;
        text-align: center;
      }

      .addressTips {
        p:last-child {
          margin-top: 24px;
          color: #ff1a3f;
        }

        .specBox {
          width: 100%;
          max-height: 500px;
          overflow-y: scroll;

          .spectitle {
            color: #333;
            font-weight: 500;
            font-size: 28px;
          }

          .specList {
            display: flex;
            flex-wrap: wrap;
            width: 100%;
            margin-top: 10px;

            li {
              display: flex;
              align-items: center;
              justify-content: center;
              box-sizing: border-box;
              width: 156px;
              height: 76px;
              margin: 10px 7px;
              padding: 4px;
              color: #787878;
              font-size: 24px;
              line-height: 30px;
              border: 1px solid #ff1a3f;
              border-radius: 6px;
            }

            li.active {
              color: #fff;
              background-color: #ff1a3f;
            }
          }
        }
      }
    }

    .prizePopupBtn {
      display: flex;
      align-items: center;
      justify-content: center;
      width: 462px;
      height: 88px;
      margin: 0 auto;
      color: #fff;
      font-size: 28px;
      background: #ff1a3f;
      border-radius: 44px;
    }
  }
}

/* stylelint-disable */

::v-deep .van-overlay,
::v-deep .van-popup--center {
  z-index: 1000000 !important;
}

.showPopUp {
  box-sizing: border-box;
  background: #fff;
  z-index: 100000000 !important;
}

::v-deep .van-popup {
  border-radius: 14px 14px 0 0;
}

/* stylelint-enable */
.close-btn {
  position: absolute;
  top: 67px;
  right: 29px;
  z-index: 999;
  display: flex;
  color: #a8a8a8;

  i {
    font-size: 40px;
  }
}
</style>
